import { createMuiTheme } from '@material-ui/core/styles';
import { orange, grey } from '@material-ui/core/colors';

const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: "#29294B",
    }
  },
});

export default darkTheme;
